module.exports = __webpack_public_path__ + "img/BobStewart@2x.be73eb17.png";